"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Alert = _interopRequireDefault(require("@mui/material/Alert"));

var _hooks = require("@alycecom/hooks");

var _Buttons = require("../Buttons");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _AlyceLoading = _interopRequireDefault(require("../AlyceLoading/AlyceLoading"));

var _VidyardIntegrationModal = _interopRequireDefault(require("./VidyardIntegrationModal"));

var _videoIntegration = require("./videoIntegration.constants");

var VidyardIcon = function VidyardIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, ".cls-1", "{", "fill:#5b627d", "}", ".cls-2", "{", "fill:#46db83", "}", ".cls-3", "{", "fill:#fff", "}")), /*#__PURE__*/_react["default"].createElement("title", null, "Full"), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M67.59 32.19a45.65 45.65 0 0 1 10.91 1.32 1.91 1.91 0 0 0 2.21-1.17 1.91 1.91 0 0 0-1.33-2.54A49.34 49.34 0 0 0 56 29.74a1.91 1.91 0 0 0-1.33 2.55 1.89 1.89 0 0 0 2.2 1.17 45.66 45.66 0 0 1 10.72-1.27zM91.14 37.35a1.93 1.93 0 0 0 .86 1.91 45.77 45.77 0 1 1-48.69-.11 1.92 1.92 0 0 0 .89-1.92 1.91 1.91 0 0 0-2.88-1.33A49.6 49.6 0 1 0 94 36a1.91 1.91 0 0 0-2.86 1.35z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M77.86 50.35a52.39 52.39 0 0 0-7.32-1c-1 0-2-.08-3-.08a52 52 0 0 0-8.89.75 53.06 53.06 0 0 0-17.47 6.48 52.45 52.45 0 0 0-9.77 7.38 3.26 3.26 0 0 0-1 2.76l4.75 37.87a41.87 41.87 0 0 0 64.85 0l.72-5.73a14 14 0 0 0 7.2-12.57 14.47 14.47 0 0 0-4.31-10.5l1.14-9.07a3.2 3.2 0 0 0-.93-2.7 52.17 52.17 0 0 0-26-13.59z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M63 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.53-4.85-10.53-11.3s4.53-11.3 10.53-11.3a10.13 10.13 0 0 1 6.83 2.57 11.56 11.56 0 0 1 3.69 8.73A11.15 11.15 0 0 1 63 96.36zM99.43 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.52-4.85-10.52-11.3s4.52-11.3 10.52-11.3a10.13 10.13 0 0 1 6.83 2.57 11.53 11.53 0 0 1 3.69 8.73 11.15 11.15 0 0 1-5.75 10.15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50.44 52.22l-3.35-21.43a6.4 6.4 0 0 1-1.79-12.62A6.48 6.48 0 0 1 53 22.8a6.41 6.41 0 0 1-3.27 7.29l7.8 20.21a51.84 51.84 0 0 0-7.08 1.92zM77.86 50.34l7.81-20.25a6.4 6.4 0 0 1 4.76-11.82 6.4 6.4 0 0 1-2.14 12.52c-1 6.23-2.19 14-3.37 21.49a53.86 53.86 0 0 0-7.06-1.95z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-3",
    d: "M63 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.53-4.85-10.53-11.3s4.53-11.3 10.53-11.3a10.13 10.13 0 0 1 6.83 2.57 11.56 11.56 0 0 1 3.69 8.73A11.15 11.15 0 0 1 63 96.36zM99.43 96.36a10.37 10.37 0 0 1-4.77 1.15c-6 0-10.52-4.85-10.52-11.3s4.52-11.3 10.52-11.3a10.13 10.13 0 0 1 6.83 2.57 11.53 11.53 0 0 1 3.69 8.73 11.15 11.15 0 0 1-5.75 10.15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M95.49 82.05a3.26 3.26 0 0 0-2.75-1.59A3.22 3.22 0 0 0 90 81.92a7.18 7.18 0 0 0-1.17 3.86 6.72 6.72 0 0 0 1.07 4 3.12 3.12 0 0 0 5.47 0A6.12 6.12 0 0 0 96.55 86a6.6 6.6 0 0 0-1.06-3.95z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-3",
    cx: "93.43",
    cy: "84.14",
    r: "1.32"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M59.08 82.05a3.26 3.26 0 0 0-2.75-1.59 3.22 3.22 0 0 0-2.72 1.46 7.18 7.18 0 0 0-1.17 3.86 6.72 6.72 0 0 0 1.07 4 3.12 3.12 0 0 0 5.47 0A6.12 6.12 0 0 0 60.14 86a6.6 6.6 0 0 0-1.06-3.95z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-3",
    cx: "57.01",
    cy: "84.14",
    r: "1.32"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M110.22 119.79a1.42 1.42 0 0 0 .84-1.35c0-1.06-.76-1.55-1.9-1.55h-1.52a.64.64 0 0 0-.64.64v3.34a.64.64 0 0 0 .64.64.65.65 0 0 0 .64-.64v-.81h.59l1 1.21a.62.62 0 0 0 .49.24.63.63 0 0 0 .64-.61.65.65 0 0 0-.17-.45zm-1.13-.74h-.81V118h.81c.44 0 .69.2.69.54s-.25.51-.69.51z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M108.88 123.88a4.69 4.69 0 1 1 4.61-4.69 4.65 4.65 0 0 1-4.61 4.69zm0-8.55a3.86 3.86 0 1 0 3.8 3.86 3.83 3.83 0 0 0-3.8-3.86z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M110.22 119.79a1.42 1.42 0 0 0 .84-1.35c0-1.06-.76-1.55-1.9-1.55h-1.52a.64.64 0 0 0-.64.64v3.34a.64.64 0 0 0 .64.64.65.65 0 0 0 .64-.64v-.81h.59l1 1.21a.62.62 0 0 0 .49.24.63.63 0 0 0 .64-.61.65.65 0 0 0-.17-.45zm-1.13-.74h-.81V118h.81c.44 0 .69.2.69.54s-.25.51-.69.51z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M108.88 123.88a4.69 4.69 0 1 1 4.61-4.69 4.65 4.65 0 0 1-4.61 4.69zm0-8.55a3.86 3.86 0 1 0 3.8 3.86 3.83 3.83 0 0 0-3.8-3.86z"
  }));
};

VidyardIcon.defaultProps = {
  id: "Layer_1",
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 135.19 145.55"
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    box: function box(_ref2) {
      var image = _ref2.image;
      return {
        width: 280,
        height: 200,
        borderRadius: 5,
        border: "2px solid ".concat(palette.link.main),
        backgroundColor: palette.additional.blue10,
        margin: spacing(2),
        marginLeft: 30,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        flexDirection: 'column',
        display: 'flex',
        backgroundImage: image ? "url(".concat(image, ") contain") : undefined
      };
    },
    icon: {
      marginRight: spacing(1)
    },
    supportLink: {
      display: 'inline-block'
    },
    wideBox: {
      width: '400px !important',
      cursor: 'default !important'
    }
  };
});
var MAX_LOAD_ATTEMPTS = 4;

var VidyardIntegration = function VidyardIntegration(_ref3) {
  var handleSelect = _ref3.handleSelect,
      image = _ref3.image,
      link = _ref3.link,
      _ref3$overrideClasses = _ref3.overrideClasses,
      overrideClasses = _ref3$overrideClasses === void 0 ? {} : _ref3$overrideClasses,
      onShowModal = _ref3.onShowModal,
      onRemove = _ref3.onRemove,
      _ref3$vidyardClientId = _ref3.vidyardClientId,
      vidyardClientId = _ref3$vidyardClientId === void 0 ? '' : _ref3$vidyardClientId,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  var classes = useStyles({
    image: image
  });

  var _useTheme = (0, _material.useTheme)(),
      colors = _useTheme.palette;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var _useState3 = (0, _react.useState)(!!(link && image)),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isVideoSelected = _useState4[0],
      setIsVideoSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(_videoIntegration.VIDYARD_LOAD_STATUS.LOADING),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      status = _useState6[0],
      setStatus = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      loadScriptAttempts = _useState8[0],
      setLoadScriptsAttempts = _useState8[1];

  var onVidyardLoadSuccess = (0, _react.useCallback)(function () {
    return setStatus(_videoIntegration.VIDYARD_LOAD_STATUS.LOADED);
  }, []);
  var onVidyardLoadFail = (0, _react.useCallback)(function () {
    setStatus(_videoIntegration.VIDYARD_LOAD_STATUS.ERROR);
    setLoadScriptsAttempts(function (attempts) {
      return attempts + 1;
    });
  }, []);

  var _useJavascript = (0, _hooks.useJavascript)(_videoIntegration.VIDYARD_LIBRARY_LINK, onVidyardLoadSuccess, onVidyardLoadFail),
      injectJavascript = _useJavascript.injectJavascript,
      injectedScripts = _useJavascript.injectedScripts;

  (0, _react.useEffect)(function () {
    injectJavascript();
  }, [injectJavascript]);
  (0, _react.useEffect)(function () {
    if (injectedScripts.has(_videoIntegration.VIDYARD_LIBRARY_LINK)) {
      setStatus(_videoIntegration.VIDYARD_LOAD_STATUS.LOADED);
    }
  }, [injectedScripts]);
  var handleVidyardPopup = (0, _react.useCallback)(function () {
    if (status === _videoIntegration.VIDYARD_LOAD_STATUS.LOADED) {
      if (onShowModal) {
        onShowModal();
      }

      setModalVisibility(true);
    }
  }, [onShowModal, status]);
  var handleRemove = (0, _react.useCallback)(function () {
    setIsVideoSelected(false);

    if (!disabled) {
      onRemove();
    }
  }, [onRemove, disabled]);
  var handleSelectVideo = (0, _react.useCallback)(function (value) {
    if (!disabled) {
      handleSelect(value);
      setIsVideoSelected(true);
    }

    setModalVisibility(false);
  }, [handleSelect, disabled]);
  var handleCloseModal = (0, _react.useCallback)(function () {
    return setModalVisibility(false);
  }, []);
  var handleReloadPage = (0, _react.useCallback)(function () {
    setStatus(_videoIntegration.VIDYARD_LOAD_STATUS.LOADING);
    injectJavascript();
  }, [injectJavascript]);
  var handleContactSupport = (0, _react.useCallback)(function () {
    window.open('https://www.alyce.com/contact-support', '_blank');
  }, []);
  var canReloadScript = loadScriptAttempts < MAX_LOAD_ATTEMPTS;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_VidyardIntegrationModal["default"], {
    vidyardClientId: vidyardClientId,
    open: isModalVisible,
    handleSelect: handleSelectVideo,
    onClose: handleCloseModal
  }), isVideoSelected ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.box, overrideClasses.boxImage)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: "100%",
    alt: "video preview",
    src: image
  })), !disabled && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "flex-end",
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_Buttons.BaseButton, {
    color: colors.common.white,
    bgColor: colors.error.main,
    hoverColor: colors.common.white,
    hoverBgColor: colors.error.dark,
    onClick: handleRemove,
    width: 110
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: classes.icon,
    icon: "trash-alt",
    color: "white"
  }), "Remove"))) : /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: (0, _classnames["default"])(classes.box, (0, _defineProperty2["default"])({}, classes.wideBox, [_videoIntegration.VIDYARD_LOAD_STATUS.ERROR, _videoIntegration.VIDYARD_LOAD_STATUS.LOADING].includes(status)), overrideClasses.box),
    onClick: handleVidyardPopup
  }, status === _videoIntegration.VIDYARD_LOAD_STATUS.LOADING && /*#__PURE__*/_react["default"].createElement(_AlyceLoading["default"], {
    isLoading: true
  }), status === _videoIntegration.VIDYARD_LOAD_STATUS.LOADED && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(VidyardIcon, {
    width: 40,
    height: 40
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    className: "Body-Regular-Center-Link-Bold"
  }, "Launch Vidyard")), status === _videoIntegration.VIDYARD_LOAD_STATUS.ERROR && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    height: 1,
    p: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "error",
    action: canReloadScript && /*#__PURE__*/_react["default"].createElement(_material.Box, {
      color: "link.main"
    }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
      color: "inherit",
      size: "small",
      onClick: handleReloadPage
    }, "Try again"))
  }, "There was an issue loading the Vidyard script. Please refresh the page and try again or\xA0", /*#__PURE__*/_react["default"].createElement(_Buttons.LinkButton, {
    className: classes.supportLink,
    onClick: handleContactSupport
  }, "Contact Support")))));
};

var _default = /*#__PURE__*/(0, _react.memo)(VidyardIntegration);

exports["default"] = _default;